export type StageDisplay = {
  readonly label: string
  readonly description?: string
  readonly icon?: string
}

export type Stage = {
  readonly id: number | string
  readonly labelId: string
  readonly display: StageDisplay
}

export enum FinderStageId {
  ready = 'ready',
  sentToInvestor = 'sent-to-investor',
  acceptedByInvestor = 'accepted-by-investor',
  rejectedByInvestor = 'rejected-by-investor',
  watchedByInvestor = 'watched-by-investor',
  waitingInInvestorBacklog = 'waiting-in-investor-backlog',
  rejectedByNetworkManager = 'rejected-by-network-manager',
}
